import { attr } from '@ember-data/model';

import type { Changes } from 'webapp/models-custom/board-state';
import BoardRecord from 'webapp/models/board';

export default class BoardPreviewRecord extends BoardRecord {
	@attr('string') previewHash!: string;
	@attr('object', {
		defaultValue() {
			return {};
		},
	})
	changes!: Changes;
	@attr('number') previewCreatedBy!: number;
	@attr('number') boardId!: number;
	@attr('number') boardPreviewId!: number;
}
